export function getBrowserDetails() {
	const ua = navigator.userAgent.toLowerCase();

	let name = 'Unknown';
	let version = '';
	let device = 'Desktop';
	let os = 'Unknown';
	let inAppBrowser = null;
	let inAppBrowserVersion = '';

	if (/ipad/i.test(ua)) {
		device = 'iPad';
	} else if (/silk/.test(ua) || /\bkf[a-z0-9]+/.test(ua)) {
		device = 'Kindle Fire';
	} else if (/kindle/.test(ua) && !/silk/.test(ua)) {
		device = 'Kindle (E-Ink)';
	} else if (/mobile|android|iphone|ipod/i.test(ua)) {
		device = 'Mobile';
	}

	// Detect OS
	if (/android/i.test(ua)) {
		os = ua.match(/android\s+([\d.]+)/i)?.[0] || 'Android';
		os = os?.charAt(0)?.toUpperCase() + os?.slice(os);
	} else if (/iphone|ipad|ipod/i.test(ua) || (/darwin\/\d+/i.test(ua) && /cfnetwork/i.test(ua) && !/macintosh|mac os x|mac os/i.test(ua))) {
		os = 'iOS';
	} else if (/windows/i.test(ua)) {
		os = 'Windows';
	} else if (/macintosh|mac os|mac os x/i.test(ua) || /darwin\/\d+/i.test(ua)) {
		os = 'macOS';
	} else if (/kaios/.test(ua)) {
		os = 'KaiOS';
	} else if (/linux/i.test(ua)) {
		os = 'Linux';
	}

	// Detect in-app browsers
	if (/(fbav|fban|fbios)(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Facebook';
		inAppBrowserVersion = ua.match(/(fbav)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/instagram(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Instagram';
		inAppBrowserVersion = ua.match(/instagram(?:\/|\s)(\d+)/i)?.[1];
	} else if (/(messenger|fban\/messenger|fban\/messengerliteforios)(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Messenger';
		inAppBrowserVersion = ua.match(/(messenger|fban\/messenger|fbav)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/\[?(tiktok|ttwebview)\]?(?:\/|\s)/i.test(ua) || (/\bwv\b/i.test(ua)
		&& (/bytedancewebview|bytelocale/.test(ua) || /appname(?:\/|\s)(trill|musical_ly|ultralite)/i.test(ua)))) {
		inAppBrowser = 'TikTok';
		inAppBrowserVersion = ua.match(/(tiktok|ttwebview)(?:\/|\s)(\d+)/i)?.[2] || ua.match(/appname\/(trill|musical_ly|ultralite)(?:\/|\s)(\d+)/i)?.[2] || '';
	} else if (/twitter(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Twitter';
		inAppBrowserVersion = ua.match(/twitter(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\[?(linkedinapp|linkedin)\]?(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'LinkedIn';
		inAppBrowserVersion = ua.match(/\[?(linkedinapp|linkedin)\]?(?:\/|\s)(\d+)/i)?.[2];
	} else if (/pinterest(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Pinterest';
		inAppBrowserVersion = ua.match(/pinterest(?:\/|\s)(\d+)/i)?.[1];
	} else if (/snapchat(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Snapchat';
		inAppBrowserVersion = ua.match(/snapchat(?:\/|\s)(\d+)/i)?.[1];
	} else if (/whatsapp(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'WhatsApp';
		inAppBrowserVersion = ua.match(/whatsapp(?:\/|\s)(\d+)/i)?.[1];
	} else if (/(gmail|gsa)(?:\/|\s)/i.test(ua) || /com\.google\.android\.gm/i.test(ua)) {
		inAppBrowser = 'Gmail';
		inAppBrowserVersion = ua.match(/(gmail|gsa)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/(outlook-ios|outlook-android|microsoft outlook)\//i.test(ua)) {
		inAppBrowser = 'Outlook';
		inAppBrowserVersion = ua.match(/(outlook-ios|outlook-android)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/\b(yahoomail|ymail)\b(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Yahoo';
		inAppBrowserVersion = ua.match(/\b(yahoomail|ymail)\b(?:\/|\s)(\d+)/i)?.[2];
	} else if (/\[?spark\]?(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Spark';
		inAppBrowserVersion = ua.match(/spark(?:\/|\s)(\d+)/i)?.[1];
	} else if (/edisonmail(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Edison';
		inAppBrowserVersion = ua.match(/edisonmail(?:\/|\s)(\d+)/i)?.[1];
	} else if (/(baiduboxapp|baidubrowser|baiduhd)(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Baidu';
		inAppBrowserVersion = ua.match(/(baiduboxapp|baidubrowser|baiduhd)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/copilotsapphire\//i.test(ua)) {
		inAppBrowser = 'Copilot';
		inAppBrowserVersion = ua.match(/copilotsapphire(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\bpolymail\b(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'Polymail';
		inAppBrowserVersion = ua.match(/polymail(?:\/|\s)(\d+)/i)?.[1];
	} else if (/protonmail(?:\/|\s)/i.test(ua)) {
		inAppBrowser = 'ProtonMail';
		inAppBrowserVersion = ua.match(/protonmail(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\bwv\b/i.test(ua) && /android/i.test(ua)) {
		inAppBrowser = 'Android WebView';
	} else if (/wkwebview|mobile\/[\d.]+/i.test(ua) && !/safari|android/i.test(ua)) {
		inAppBrowser = 'iOS WebView';
	}

	// Detect browser + version
	if (/(edg|edgios|edga)(?:\/|\s)/i.test(ua)) {
		name = 'Edge';
		version = ua.match(/(edg|edgios|edga)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/(opr|opera|opios)(?:\/|\s)/i.test(ua)) {
		name = 'Opera';
		version = ua.match(/(opr|opera|opios)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/brave(?:\/|\s)/i.test(ua)) {
		name = 'Brave';
		version = ua.match(/chrome|brave(?:\/|\s)(\d+)/i)?.[1];
	} else if (/samsungbrowser/i.test(ua)) {
		name = 'Samsung Internet';
		version = ua.match(/samsungbrowser(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\barc\b(?:\/|\s)/i.test(ua)) {
		name = 'Arc';
		version = ua.match(/\barc\b(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\bvivaldi\b/i.test(ua)) {
		name = 'Vivaldi';
		version = ua.match(/\bvivaldi\b(?:\/|\s)(\d+)/i)?.[1];
	} else if (/\bduckduckgo\b/i.test(ua)) {
		name = 'DuckDuckGo';
		version = ua.match(/\bduckduckgo\b(?:\/|\s)(\d+)/i)?.[1];
	} else if (/kiwibrowser/i.test(ua) || /kiwichrome/i.test(ua)) {
		name = 'Kiwi';
		version = ua.match(/(kiwibrowser|kiwichrome)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/\becosia\b/i.test(ua)) {
		name = 'Ecosia';
		version = ua.match(/\becosia\b(?:\/|\s)(\d+)/i)?.[1];
	} else if (/ucbrowser|ucweb/i.test(ua)) {
		name = 'UC';
		version = ua.match(/(ucbrowser|ucweb)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/\bwaterfox\b/i.test(ua)) {
		name = 'Waterfox';
		version = ua.match(/\bwaterfox\b(?:\/|\s)(\d+)/i)?.[1];
	} else if (/mqqbrowser|qqbrowserLite/i.test(ua)) {
		name = 'QQ';
		version = ua.match(/(mqqbrowser|qqbrowserLite)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/baidubrowser|baiduhd/i.test(ua)) {
		name = 'Baidu';
		version = ua.match(/(baidubrowser|baiduhd)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/miuibrowser|mibrowser/i.test(ua)) {
		name = 'MiUi';
		version = ua.match(/(miuibrowser|mibrowser)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/yabrowser|yandex/i.test(ua)) {
		name = 'Yandex';
		version = ua.match(/yabrowser(?:\/|\s)(\d+)/i)?.[1];
	} else if (/silk/i.test(ua)) {
		name = 'Silk';
		version = ua.match(/silk(?:\/|\s)(\d+)/i)?.[1];
	} else if (/kindle/.test(ua) && !/silk/.test(ua)) {
		name = 'Kindle';
		version = ua.match(/kindle(?:\/|\s)(\d+)/i)?.[1];
	} else if (/kaios/.test(ua)) {
		name = 'KaiOS';
		version = ua.match(/kaios(?:\/|\s)(\d+)/i)?.[1];
	} else if (/(chrome|crios)(?:\/|\s)/i.test(ua) && !/edg|edga|edgios|opr|opios|opera/i.test(ua)) {
		name = 'Chrome';
		version = ua.match(/(chrome|crios)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/(firefox|fxios)(?:\/|\s)/i.test(ua)) {
		name = 'Firefox';
		version = ua.match(/(firefox|fxios)(?:\/|\s)(\d+)/i)?.[2];
	} else if (/safari/i.test(ua) && !/chrome|opr|edg|crios|fxios|edgios|opios/i.test(ua)) {
		name = 'Safari';
		version = ua.match(/version(?:\/|\s)(\d+)/i)?.[1];
	} else if (/msie|trident/i.test(ua)) {
		name = 'Internet Explorer';
		version = ua.match(/(msie|rv:)(?:\/|\s)(\d+)/i)?.[2];
	}

	// Build strings
	const readable = [
		inAppBrowser ? `${inAppBrowser} In-App` : name,
		version ? `v${version}` : '',
		`(${device}, ${os})`
	].filter(Boolean).join(' ');

	const compact = [
		`${inAppBrowser ? `${inAppBrowser.replace(/\s+/g, '')}_InApp${inAppBrowserVersion || ''}` : `${name}${version || ''}`}`,
		device,
		os.replace(/\s+|[0-9.]/g, '')
	].filter(Boolean).join('|');

	return {
		name,
		version: version || 'Unknown',
		device,
		os,
		inAppBrowser: inAppBrowser || 'None',
		inAppBrowserVersion,
		readable,
		compact,
		userAgent: navigator.userAgent
	};
}
